import type { ViewState } from '#components/Root/viewModel'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import TextArea from '../IFormComponents/TextArea'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomSendCompatibilityRequest')

type Props = {
  state: ViewState
  viewModel: ViewModel
  requiredMessage?: boolean
}

const CustomSendRequest = ({
  state,
  viewModel,
  requiredMessage = false,
}: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph className={styles.title} variant='subtitle1'>
        {state.currentNode.text}
      </Paragraph>
      <Paragraph className={styles.title} variant='body2'>
        {state.currentNode.subtext}
      </Paragraph>
      {viewModel.showGivenInfo && (
        <React.Fragment>
          <Paragraph variant='subtitle1'>{tp('given-info')}</Paragraph>
          <ul>
            {viewModel.givenCar && (
              <li>
                {`${tp('given-car')}: `}
                <strong>{viewModel.givenCar}</strong>
              </li>
            )}
            {viewModel.givenEngine && (
              <li>
                {`${tp('given-engine')}: `}
                <strong>{viewModel.givenEngine}</strong>
              </li>
            )}
          </ul>
        </React.Fragment>
      )}
      <div className={styles.formContainer}>
        {/* @ts-expect-error@2322 */}
        <IForm
          className={styles.form}
          data={viewModel.data}
          onChange={viewModel.handleFormChange}
          onValid={viewModel.handleFormValid}
        >
          {/* @ts-expect-error@2322 */}
          <TextField label={tp('name')} property='name' required />
          <TextField
            label={tp('email')}
            property='requestEmail'
            required
            // @ts-expect-error@2322
            validators={viewModel.emailValidator}
          />
          <TextField
            label={tp('phone')}
            optional
            property='telephone'
            // @ts-expect-error@2322
            validators={viewModel.phoneValidator}
          />
          <TextArea
            className={styles.textArea}
            placeholder={tp('message')}
            property='message'
            required={requiredMessage}
          />
        </IForm>
      </div>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      customCaptions={{ next: tp('send') }}
      loading={viewModel.loading}
      nextEnabled={viewModel.isValid}
      onNext={viewModel.handleSend}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomSendRequest)
component.displayName = 'CustomSendRequest'
export default component
